<template>
    <vs-popup class="holamundo" :title="'Contacting to '+user.firstname+' '+user.lastname" :active.sync="displayContactModal">
        <div class="addCardFont font-semibold ml-5">Email</div>
        <vs-input 
            class="w-full p-5 pt-4"
            v-model="user.email" 
            :danger="errors.email.success"
            :danger-text="errors.email.msg"
            @input="validateEmail($event)" 
            :disabled="true"
            maxLength="60" 
        />
        <div class="addCardFont font-semibold ml-5">Subject</div>
        <vs-input 
            class="w-full p-5 pt-4"
             v-model="subject" 
            :danger="errors.subject.success"
            :danger-text="errors.subject.msg"
            @input="validateSubject($event)" 
            maxLength="60" 
        />
        <div class="addCardFont font-semibold ml-5">Body</div>
        <vs-textarea
            style="width:94% !important;color:white !important;"
            class="w-full pl-0 pt-0 p-2 mx-5 mt-4 mb-0"
             v-model="body" 
            :danger="errors.body.success"
            :danger-text="errors.body.msg"
            @input="validateBody($event)" 
            maxLength="300" 
        />
        <div v-show="errors.body.success" class="text-danger validation-msg ml-5 pl-1 mt-1">{{ errors.body.msg }}</div>
        <vs-row vs-type="flex" vs-justify="center" class="mt-5">
            <vs-button @click="sendMessage()">Send</vs-button>
        </vs-row>
    </vs-popup>
</template>

<script>
import { validateEmail, validateSubject, validateBody } from '@/views/admin/validation';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
    props: {
        displayContactModal: {
            type: Boolean
        },
        user: {
            type: [ Object, String ]
        }
    },
    data(){
        return {
            subject: '',
            body: '', 

            validateEmail,
            validateSubject,
            validateBody,

            errors: {
                email: {
                    msg: '',
                    success: false
                },
                subject: {
                    msg: '',
                    success: false
                },
                body: {
                    msg: '',
                    success: false
                }
            },

            toast,
            genericErrorMessage
        }
    },
    methods: {
        sendMessage(){
            this.validateEmail(this.user.email);
            this.validateSubject(this.subject);
            this.validateBody(this.body);
            let { email, subject, body } = this.errors;
            if(email.success || subject.success || body.success){
                return;
            }
            this.send();
        },
        send(){
            this.$vs.loading.close();
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
            this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.MessageToUser,{
                userEmail: this.user.email,
                subject: this.subject,
                body: this.body
            }, { 
                headers: {
                    'Authorization': this.$localStorage.get('token'),
                }
            }).then(async res => {
                this.$vs.loading.close();
                if(res.data.success){
                    this.toast('Message sent successfully');
                    this.$emit('update:display-contact-modal', false)
                } else {
                    this.toast(this.genericErrorMessage());
                }
            }).catch(e => {
                this.$vs.loading.close();
                this.showMerge = false;
                if(e.response && e.response.status !== 401){
                    this.toast(this.genericErrorMessage());
                }
                // console.log("Error in mergeReuests: ",e);
            });
        }
    },
    watch: {
        displayContactModal(newval, oldval){
            this.subject = ''
            this.body = ''
            this.errors = {
                email: {
                    msg: '',
                    success: false
                },
                subject: {
                    msg: '',
                    success: false
                },
                body: {
                    msg: '',
                    success: false
                }
            }
        }
    }
}
</script>

<style scoped>
    .theme-dark .vs-con-textarea {
        background-color: #343434 !important;
        color: white !important;
    }
    .validation-msg {
        font-size: 12px;
    }
    .theme-dark .vs-con-input input {
        color: #CACACA !important;
    }
</style>